import React from 'react';
import processIcon from '../../assets/img/icons/process_icon.png';

const ServiceWorkflow = ({ title, description, steps, buttonText }) => {
  const defaultSteps = [
    {
      step: "Step 1",
      title: "3D Laser Scanning / Data Collection",
      desc: "We capture accurate data of your building or site using the latest 3D laser scanning technology.",
    },
    {
      step: "Step 2",
      title: "Point Cloud Data Processing",
      desc: "Raw point cloud data is cleaned, filtered, and prepared for BIM conversion.",
    },
    {
      step: "Step 3",
      title: "BIM Model Creation",
      desc: "Our experts convert the processed data into a detailed BIM model, ready for use in design, analysis, and construction.",
    },
    {
      step: "Step 4",
      title: "Quality Check & Delivery",
      desc: "Every model undergoes rigorous quality checks to ensure precision before delivery.",
    },
  ];

  const displaySteps = steps || defaultSteps;

  return (
    <section className="onboarding-section">
      <div className="onboarding-container">
        <div className="onboarding-left">
          <div className="onboarding-sticky-wrapper">
            <h2 className="onboarding-title">
              {title || (
                <><span className="text-primary">Our Point</span> Cloud to BIM Workflow</>
              )}
            </h2>
            <p className="onboarding-text">
              {description || "Our BIM Modeling Services follow a structured workflow to deliver exceptional results:"}
            </p>
          </div>
        </div>

        <div className="onboarding-right">
          <div className="timeline-list">
            {displaySteps.map((item, index) => (
              <div key={index} className="timeline-item">
                <div className="timeline-icon-wrapper">
                  <img
                    src={processIcon.src || processIcon}
                    alt={`${item.step} Icon`}
                    style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }}
                  />
                </div>
                <div className="timeline-content">
                  <p className="timeline-step">{item.step || `Step ${index + 1}`}</p>
                  <h4 className="timeline-title">{item.title}</h4>
                  <p className="timeline-desc">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
          
          <div className="workflow-cta-container">
            <button className="onboarding-cta">{buttonText || "Choose Your Model"}</button>
          </div>
        </div>
      </div>
      
      <style jsx>{`
        .workflow-cta-container {
          margin-top: 40px;
          text-align: left;
          padding-left: 20px;
        }
        @media (max-width: 900px) {
          .workflow-cta-container {
            text-align: center;
            padding-left: 0;
            margin-top: 30px;
          }
        }
      `}</style>
    </section>
  );
};

export default ServiceWorkflow;
